import React from "react";
import "./index.css";

const Footer = () => {
  return (
    <div className="footer">
      {`Copyright © ${new Date().getFullYear()} 5thmr.org`}
    </div>
  );
};

export default Footer;
